
import GwIcon from '~/patterns/atoms/icon/icon.vue';

export default {
    components: {
        GwIcon
    },

    props: {
        openIndexes: {
            type: Array,
            required: false,
            default: () => []
        },

        items: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    data() {
        return {
            visibleRowIndexes: []
        };
    },

    created() {
        this.visibleRowIndexes = [...this.openIndexes];
    },

    methods: {
        toggleRow(index) {
            const arrayIndex = this.visibleRowIndexes.indexOf(index);

            if (arrayIndex === -1) {
                this.visibleRowIndexes.push(index);
            } else {
                this.visibleRowIndexes.splice(arrayIndex, 1);
            }
        }
    }
};
